function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// src/components/badge.ts
import { defineCssVars, defineStyle, defineStyleConfig } from "@chakra-ui/styled-system";
import { transparentize } from "@chakra-ui/theme-tools";
var vars = defineCssVars("badge", ["bg", "color", "shadow"]);
var baseStyle = defineStyle({
  px: 1,
  textTransform: "uppercase",
  fontSize: "xs",
  borderRadius: "sm",
  fontWeight: "bold",
  bg: vars.bg.reference,
  color: vars.color.reference,
  boxShadow: vars.shadow.reference
});
var variantSolid = defineStyle(function (props) {
  var _dark, _ref;

  var c = props.colorScheme,
      theme = props.theme;
  var dark = transparentize("".concat(c, ".500"), 0.6)(theme);
  return _ref = {}, _defineProperty(_ref, vars.bg.variable, "colors.".concat(c, ".500")), _defineProperty(_ref, vars.color.variable, "colors.white"), _defineProperty(_ref, "_dark", (_dark = {}, _defineProperty(_dark, vars.bg.variable, dark), _defineProperty(_dark, vars.color.variable, "colors.whiteAlpha.800"), _dark)), _ref;
});
var variantSubtle = defineStyle(function (props) {
  var _dark2, _ref2;

  var c = props.colorScheme,
      theme = props.theme;
  var darkBg = transparentize("".concat(c, ".200"), 0.16)(theme);
  return _ref2 = {}, _defineProperty(_ref2, vars.bg.variable, "colors.".concat(c, ".100")), _defineProperty(_ref2, vars.color.variable, "colors.".concat(c, ".800")), _defineProperty(_ref2, "_dark", (_dark2 = {}, _defineProperty(_dark2, vars.bg.variable, darkBg), _defineProperty(_dark2, vars.color.variable, "colors.".concat(c, ".200")), _dark2)), _ref2;
});
var variantOutline = defineStyle(function (props) {
  var _ref3;

  var c = props.colorScheme,
      theme = props.theme;
  var darkColor = transparentize("".concat(c, ".200"), 0.8)(theme);
  return _ref3 = {}, _defineProperty(_ref3, vars.color.variable, "colors.".concat(c, ".500")), _defineProperty(_ref3, "_dark", _defineProperty({}, vars.color.variable, darkColor)), _defineProperty(_ref3, vars.shadow.variable, "inset 0 0 0px 1px ".concat(vars.color.reference)), _ref3;
});
var variants = {
  solid: variantSolid,
  subtle: variantSubtle,
  outline: variantOutline
};
var badgeTheme = defineStyleConfig({
  baseStyle: baseStyle,
  variants: variants,
  defaultProps: {
    variant: "subtle",
    colorScheme: "gray"
  }
});
export { vars, badgeTheme };